import axios, { AxiosRequestConfig } from 'axios';
import env from 'config';
import { DEFAULT_HEADERS, DEFAULT_TIMEOUT } from 'constants/request';

const config: AxiosRequestConfig = {
  baseURL: env.AJAX_SERVICE_ENDPOINT,
  headers: DEFAULT_HEADERS,
  timeout: DEFAULT_TIMEOUT,
};

const client = axios.create(config);

export default client;
